import { Api } from '@shared-providers/api.provider';
import { Injectable } from '@angular/core';
import { Provider } from '@shared-providers/Provider';
import { LoadingService } from '@shared-services/loading.service';
import { IDataQuery, ITableData } from '@beego/ngx-table';
import { IWaitListItem } from '@internal-models/wait-list-item.model';
import { encodeQueryUrl } from '@shared-libs/helpers';

@Injectable({
	providedIn: 'root',
})
export class WaitListProvider extends Provider<IWaitListItem> {
	protected readonly url: string = '/wait-list-items';

	constructor(
		protected readonly api: Api,
		protected readonly loadingService: LoadingService
	) {
		super(loadingService);
	}

	public async getAll(query: IDataQuery): Promise<ITableData<IWaitListItem>> {
		return this.process(
			this.api.get(`${this.url}?query=${encodeQueryUrl(query)}`),
			!query.offset
		) as Promise<ITableData>;
	}

	public getAllOfClient(clientId: string): Promise<Array<IWaitListItem>> {
		return this.process(this.api.get(`${this.url}/client/${clientId}`)) as Promise<Array<IWaitListItem>>;
	}

	public getOne(id: string): Promise<IWaitListItem> {
		return this.process(this.api.get(`${this.url}/${id}`)) as Promise<IWaitListItem>;
	}

	public create(waitListItem: Partial<IWaitListItem>): Promise<IWaitListItem> {
		return this.process(this.api.post(`${this.url}`, waitListItem)) as Promise<IWaitListItem>;
	}

	public update(id: string, waitListItem: Partial<IWaitListItem>): Promise<IWaitListItem> {
		return this.process(this.api.put(`${this.url}/${id}`, waitListItem)) as Promise<IWaitListItem>;
	}
}
